import type { RuleHandler } from "../types";
import { setIncludes } from "utilities/promotions/setIncludes";

const checkExcludedMarketIds: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return !setIncludes(
    new Set(requirementAttributes?.excludedMarketIds),
    new Set(context.selection.marketIds),
  );
};

export { checkExcludedMarketIds };
